const PRODUCTION_ROUTE_PATTERNS: RegExp[] = [
  /^\/$/,
  /^\/news(\/|$)/,
  /^\/competitions\/(feed|current|results)(\/|$)/,
  /^\/association\/(about|board-members|disciplines|regulations-and-safety|instructions)(\/|$)/,
  /^\/profile$/,
  /^\/profile\/notifications$/,
  /^\/manage\/members\/overview(\/|$)/,
  /^\/manage\/news\/overview(\/|$)/,
  /^\/manage\/competitions$/,
  /^\/manage\/competitions\/(overview|disciplines)(\/|$)/,
  /^\/manage\/association(\/|$)/,
  /^\/manage\/roles-and-permissions$/,
  /^\/manage\/roles-and-permissions\/roles(\/|$)/,
];

export const isProductionRoute = (pathname: string): boolean => {
  return PRODUCTION_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname));
};
